import { render } from "./DetailContrat.vue?vue&type=template&id=2e91cd83"
import script from "./DetailContrat.vue?vue&type=script&lang=ts"
export * from "./DetailContrat.vue?vue&type=script&lang=ts"

import "./DetailContrat.vue?vue&type=style&index=0&id=2e91cd83&lang=css"
script.render = render

export default script